import { ProgressiveSearchModalKeys } from '@/app/(main)/_components/search-modal/search-modal.types';

export type BackNavigationResult
  = | { action: 'trigger-attention-animation' } | { action: 'jump'; key: ProgressiveSearchModalKeys; returning: boolean } | null;

const RETURN_TO_SEARCH_KEYS = new Set([
  ProgressiveSearchModalKeys.SELECT_MORE_EXAMS,
  ProgressiveSearchModalKeys.SELECTED_OVERVIEW_EXAMS,
  ProgressiveSearchModalKeys.ASK_ADD_MORE_EXAMS,
]);

export function resolveBackNavigation(
  currentKey: string,
  eventType: 'escape' | 'interact-outside',
): BackNavigationResult {
  if (
    eventType === 'interact-outside'
    || RETURN_TO_SEARCH_KEYS.has(currentKey as ProgressiveSearchModalKeys)
  ) {
    return {
      action: 'jump',
      key: ProgressiveSearchModalKeys.SEARCH,
      returning: true,
    };
  }

  return null;
}
